import React, { useState } from 'react';

const nullContextData = {
  patientId: '',
  patientFullName: '',
}

const PatientContext = React.createContext({
  ...nullContextData,
  update: (patient_id, patient_full_name) => {},
  clear: () => {},
});

const patientIdKey = 'patient-id';
const patientFullNameKey = "patient-full-name";

const writeToSessionStorage = (context) => {
  sessionStorage.setItem(patientIdKey, context.patientId);
  sessionStorage.setItem(patientFullNameKey, context.patientFullName);
}

const clearSessionStorage = () => {
  sessionStorage.removeItem(patientIdKey);
  sessionStorage.removeItem(patientFullNameKey);
}

const retrieveStoredUserData = () => {
  return {
    patientId: sessionStorage.getItem(patientIdKey) || '',
    patientFullName: sessionStorage.getItem(patientFullNameKey) || '',
  }
};

export const PatientContextProvider = (props) => {
  const [currentContextData, setCurrentContextData] = useState(retrieveStoredUserData());

  const editHandler = (patient_id, patient_full_name) => {
    const newContextData = {
      patientId: patient_id,
      patientFullName: patient_full_name,
    };
    writeToSessionStorage(newContextData);
    setCurrentContextData(newContextData);
  };

  const clearHandler = () => {
    clearSessionStorage();
    setCurrentContextData(nullContextData);
  };

  const contextValue = {
    ...currentContextData,
    update: editHandler,
    clear: clearHandler,
  }

  return (
    <PatientContext.Provider value={contextValue}>
      {props.children}
    </PatientContext.Provider>
  );
};

export default PatientContext;
